const ADDON_FEEDBACK_CONTAINER_ID = "techdocs-report-issue";
const ADDON_FEEDBACK_CONTAINER_SELECTOR = `#${ADDON_FEEDBACK_CONTAINER_ID}`;
const ADDON_ISSUE_REPO_TYPES_SUPPORTED = ["github", "gitlab"];
const PAGE_EDIT_LINK_SELECTOR = '[title^="Edit this page"]';
const PAGE_FEEDBACK_LINK_SELECTOR = '[title^="Leave feedback for"]';
const PAGE_MAIN_CONTENT_SELECTOR = '[data-md-component="main"] .md-content';

export { ADDON_FEEDBACK_CONTAINER_ID, ADDON_FEEDBACK_CONTAINER_SELECTOR, ADDON_ISSUE_REPO_TYPES_SUPPORTED, PAGE_EDIT_LINK_SELECTOR, PAGE_FEEDBACK_LINK_SELECTOR, PAGE_MAIN_CONTENT_SELECTOR };
//# sourceMappingURL=constants.esm.js.map
